//Include Both Helper File with needed methods

import {
  
  getHomeTradeConfirmData,
    
  } from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_tradeConfirmationDataThunk = createAsyncThunk("home_tradeConfirmationDataThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getHomeTradeConfirmData( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










